import Vue from 'vue'
import VueRouter from 'vue-router'

//引入页面
import login from "./subpages/Login"

Vue.use(VueRouter)

export default new VueRouter({
	routes: [{
		path: '/',
		name: 'login',
		component: login,
		meta: {
			title: ['登录']
		}
	}]
})
